import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OVERLAY_DATA } from 'src/app/shared/services/dynamic-overlay/dynamic-overlay.service';

export interface ColorPaletteOverlayData {
  colors: string[];
}

@Component({
  selector: 'app-color-palette-overlay',
  imports: [MatTooltipModule],
  template: `
    <div class="color-palette-overlay">
      <div class="color-grid">
        @for (color of data.colors; track color) {
          <div class="color-swatch" [style.background-color]="color" (click)="selectColor(color)" [matTooltip]="color"></div>
        }
      </div>
    </div>
  `,
  styles: `
    .color-palette-overlay {
      background-color: #fff;
      border-radius: 8px;
      padding: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border: 1px solid #e0e0e0;
    }
    .color-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 6px;
    }
    .color-swatch {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.1);
      transition: transform 0.1s ease-out;
    }
    .color-swatch:hover {
      transform: scale(1.15);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPaletteOverlayComponent {
  public data: ColorPaletteOverlayData = inject(OVERLAY_DATA);
  @Output() colorSelected = new EventEmitter<string>();

  selectColor(color: string): void {
    this.colorSelected.emit(color);
  }
}
